import PropTypes from 'prop-types';
import React from 'react';

import { PlayTriangle } from 'components/Icon';
import IconButton from 'components/IconButton';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const SecondaryPromoHeroPlayButton = ({ onClick }) => (
  <div className="HomepageV2SecondaryPromoHero__play-button">
    <IconButton onClick={onClick}>
      <span className="HomepageV2SecondaryPromoHero__play-button-icon">
        <PlayTriangle width={Theme.get('spacing') * 2} />
      </span>
      <span className="HomepageV2SecondaryPromoHero__play-button-text">
        {I18n.localize('dasherLandingPage.playButton')}
      </span>
    </IconButton>
    <style jsx>{`
      .HomepageV2SecondaryPromoHero__play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .HomepageV2SecondaryPromoHero__play-button-icon {
        width: ${Theme.get('spacing') * 2}px;
        margin-right: ${Theme.get('spacing') * 2.5}px;
      }

      .HomepageV2SecondaryPromoHero__play-button-text {
        font-size: ${Theme.get('font-size-description-px')};
        font-weight: ${Theme.get('font-weight-semi-bold')};
        color: ${Theme.get('colors-white')};
        padding-top: 1px;
        text-transform: uppercase;
        line-height: 1;
        letter-spacing: 2px;
      }
    `}</style>
    <style jsx global>{`
      .HomepageV2SecondaryPromoHero__play-button .IconButton {
        min-height: ${Theme.get('spacing') * 8}px;
        border-radius: ${Theme.get('border-radius-wide-px')};
        background-color: ${Theme.get('colors-black')};
        padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 4.5}px;
      }

      .HomepageV2SecondaryPromoHero__play-button:hover .IconButton {
        background-color: ${Theme.get('colors-white')};
      }

      // prettier-ignore
      .HomepageV2SecondaryPromoHero__play-button:hover .HomepageV2SecondaryPromoHero__play-button-text {
        color: ${Theme.get('colors-black')};
      }

      .HomepageV2SecondaryPromoHero__play-button:hover img {
        filter: invert(1);
      }
    `}</style>
  </div>
);

SecondaryPromoHeroPlayButton.propTypes = {
  onClick: PropTypes.func,
};

SecondaryPromoHeroPlayButton.defaultProps = {
  onClick: () => {},
};

export default SecondaryPromoHeroPlayButton;
